jQuery(document).ready(function(){
	
	jQuery(".job-filter").on("change", function(){
		
		jQuery("#job-filter-form").submit();
		
	});	
	
	jQuery("#job-listing").tablesorter();
	
	jQuery("#job-listing").bind("sortEnd",function(e, table) {
		addStriping();
	});
	
	jQuery(".job-delete").on("click", function(){
		
		var confirmText = "Are you sure you want to delete this job?";
		var current = jQuery(this);
		var jobID = current.attr("data-id");
		
		if(confirm(confirmText)) {
			
			jQuery.ajax({
				url:"/wp-admin/admin-ajax.php",
				type:'POST',
				data:'action=delete_job&job_id='+ jobID,
				success:function(results){
					
					current.parents("tr").hide();
					
				}
			});
			
		}
		
	});
	
	jQuery("#job-listing tbody tr:gt(9)").addClass("hide");
	
	jQuery("#show-all").on("click", function(){
		
		jQuery("#job-listing tbody tr.hide").removeClass("hide");
		jQuery(this).hide();
		
		addStriping();
		
	});
	
	addStriping();
	
});

function addStriping() {
	
	jQuery("#job-listing tbody tr.stripe").removeClass("stripe");
	
	var counter = 0;
	
	jQuery("#job-listing tbody tr:not(.hide)").each(function(){
		
		if(counter % 2 == 1) {
			jQuery(this).addClass("stripe");
		}
		
		counter++;
		
	});
	
}
